/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ActivityMini.vue?vue&type=template&id=8d896d06&scoped=true"
import script from "./ActivityMini.ts?vue&type=script&lang=ts&external"
export * from "./ActivityMini.ts?vue&type=script&lang=ts&external"
import style0 from "./ActivityMini.vue?vue&type=style&index=0&id=8d896d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d896d06",
  null
  
)

export default component.exports